import { CSSProperties } from "react";

import { ListCard } from "../../../ListCard";
import { ButtonSkeleton } from "../ButtonSkeleton/ButtonSkeleton";

import styles from "./PolicySectionSkeleton.module.scss";

type PolicySectionSkeletonProps = {
  title?: string;
  hasButton?: boolean;
  className?: string;
  style?: CSSProperties;
};

const Item = () => (
  <ListCard.Row>
    <div className={styles.sectionDetailRow}>
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
    </div>
  </ListCard.Row>
);

const Button = () => (
  <div className={styles.sectionDetailRow}>
    <ButtonSkeleton />
  </div>
);

export const PolicySectionSkeleton = ({
  className,
  style,
  title,
  hasButton,
}: PolicySectionSkeletonProps) => (
  <ListCard className={className} style={style}>
    {title && <ListCard.Header>{title}</ListCard.Header>}
    <Item />
    <Item />
    <Item />
    <Item />
    {hasButton && (
      <ListCard.Footer className={styles.footer}>
        <Button />
      </ListCard.Footer>
    )}
  </ListCard>
);
